import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Satellite, UpdateSatelliteDto } from 'types';

export const updateSatellite = ({
  data,
  satelliteId,
}: {
  data: UpdateSatelliteDto;
  satelliteId: number;
}): Promise<Satellite> => {
  return axios.put(`/api/satellites/${satelliteId}`, data);
};

type UseUpdateSatelliteOptions = {
  config?: MutationConfig<typeof updateSatellite>;
};

export const useUpdateSatellite = ({ config }: UseUpdateSatelliteOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousSatellites) {
        queryClient.setQueryData(['satellites'], context.previousSatellites);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['satellites']);
      queryClient.invalidateQueries(['systemOverview']);
    },
    ...config,
    mutationFn: updateSatellite,
  });
};
